export default __webpack_public_path__ + "9a029778a1f2af3fd86800cef29b9ffd.svg";